export default {
  handleGeneral(error) {
    if (error === 'Failed to fetch') {
      return 'Please check your network connection and try again.'
    }
    return error
  },
  handleBusinessError(errorCode, statusText) {
    if (errorCode) {
      if (errorCode === 'INVALID_OWNERID_NOT_NULL') {
        return "Can't find owner info"
      }
    }
    return statusText
  },
}
